<template>
    <div class="col-12 nopads">
        <top-bar
            @onSignInClicked="showLogin"
            @onSearchClicked="searchView"/>
        <alert
            :show="alertVisible"
            :message="message"
            :variant="variant"
            @alertShown=alertShown
            @alertDismiss="alertDismiss"
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <transition name="fade">
                    <login v-if="showLogIn"
                           @loginAdmin="showAdminView"
                           @loginUser="showCampaignView"
                           @alert="showAlert"
                           @close="showMain"
                           @resetClose="showNote">
                    </login>
                </transition>
                <div class="mx-auto ml-auto" v-if="!showLogIn">
                    <bread-crumbs :breadcrumbs="this.breadcrumbs" />
                    <b-container v-if="organization && organization.category === 4" class="mb-4 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3>{{ $t("common.clubs_and_associations") }}</h3>
                        </b-col>
                      <team-feed :organization-id="this.organizationId"/>
                    </b-container>
                    <b-container v-else class="mb-4 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3>{{ $t("common.donation_targets") }}</h3>
                        </b-col>
                        <campaign-feed :organization-id="this.organizationId" />
                    </b-container>
                </div>
            </div>
            <footer-area />
        </div>
    </div>

</template>

<script>
import Login from "../components/Login";
import Alert from '../components/Alert'
import {alertMixin} from "../mixins/AlertMixin";
import CampaignFeed from "../components/feed/CampaignFeed";
import TopBar from "../components/TopBar";
import TeamFeed from "../components/feed/TeamFeed";
import FooterArea from "../components/FooterArea";
import FairApi from "@/modules/api";
import BreadCrumbs from "@/components/BreadCrumbs";

export default {
    name: "OrganizationCampaignsView",
    mixins: [alertMixin],
    components: {BreadCrumbs, FooterArea, TopBar, Alert, Login, TeamFeed, CampaignFeed}, //CampaignFeed,
    data() {
        return {
            showLogIn: false,
            showSearchField: false,
            category: -1,
            note: false,
            organizationId: null,
            organization: {},
            loading: true,
            breadcrumbs: []
        }
    },

    mounted: function () {
        this.organizationId = parseInt(this.$route.params.id);
    },

    watch: {
        organizationId: function () {
            if (this.organizationId !== null) {
                this.fetchOrganization()
            }
        }
    },

    methods: {
        searchView : function () {
            this.showLogIn = false
            this.$router.push({name: 'search-view'})
        },

        showLogin: function () {
            this.showLogIn = true
        },

        showMain: function () {
            this.showLogIn = false
        },

        showNote: function () {
            this.note = true
            this.showAlert(this.$t('login.link_send'), "info")
        },

        alertDismiss: function () {
            if (this.note) {
                this.showLogIn = false
                this.note = false
            }
        },

        fetchOrganization: function () {
            this.loading = true
            this.visibleResults = []
            let param = {organizationId: this.organizationId}
            FairApi.getWithParams(FairApi.organization(), param, this.success, this.failed)
        },

        success: function (response) {
            this.results = response.filter((item) =>  item.id === this.organizationId)
            this.organization = this.results[0];
            this.loading = false
            this.setBreadcrumbs()
        },

        failed: function () {
            this.loading = false
        },

        setBreadcrumbs: function () {
            this.breadcrumbs = [
                {
                    text: "breadcrumbs.front_page",
                    translate: true,
                    route: 'main-view',
                    disabled: false,
                    active: false
                },
                {
                    text: "categories." + this.organization.category,
                    translate: true,
                    route: 'category-organizations-view',
                    disabled: false,
                    active: false,
                    params: { id: this.organization.category }
                },
                {
                    text: this.organization.name,
                    translate: false,
                    route: 'teams-list-view',
                    disabled: true,
                    active: true
                },
            ]
        },

        showAdminView: function () {
          this.showLogIn = false
          this.$router.push({name: 'admin-view'})
        },

        showCampaignView: function () {
          this.showLogIn = false
        },
    }
}
</script>

<style scoped>

</style>